import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue'

import BaseChart from '@/base-ui/chart'


export default _defineComponent({
  props: {
    title: { type: String, required: false, default: '' },
    xLabels: { type: Array, required: true },
    yValues: { type: Array, required: true }
  } as unknown as undefined,
  setup(__props: {
    title?: string
    xLabels: string[]
    yValues: any[]
  }) {

const props = __props


const options = computed(() => {
  return {
    title: {
      text: props.title
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985'
        }
      }
    },
    toolbox: {
      feature: {
        saveAsImage: { show: true, title: 'save' }
      }
    },
    legend: {},
    // 上下左右間距
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: false,
        data: props.xLabels
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [
      {
        name: '分類銷量',
        type: 'line',
        stack: '總量',
        areaStyle: {},
        emphasis: {
          focus: 'series'
        },
        data: props.yValues
      }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BaseChart), { options: _unref(options) }, null, 8, ["options"])
  ]))
}
}

})